
import { Inbox, Landmark, LayoutDashboard, Globe, BookOpen, Plus, Stamp, BarChart3, CalendarClock, Trophy, MessagesSquare, type LucideIcon } from 'lucide-react';

export interface PortalNavLink {
  label: string;
  to?: string;
  href?: string;
  icon?: LucideIcon;
  staffOnly?: boolean;
  approvalsBadge?: boolean;
  messengerBadge?: boolean;
  permission?: string;
  hint: string;
}

export const PORTAL_PRIMARY: PortalNavLink[] = [
  { label: 'Обращения', to: '/tickets', icon: Inbox,
    hint: 'Заявки, которые вы\u00a0создали или\u00a0можете видеть' },
  { label: 'Согласования', to: '/approvals', icon: Stamp, approvalsBadge: true,
    hint: 'Заявки, которые ждут вашего решения' },
  { label: 'Рабочий стол', to: '/tickets/workspace', icon: LayoutDashboard, staffOnly: true,
    hint: 'Заявки в\u00a0работе у\u00a0вас и\u00a0вашей группы' },
  { label: 'Спринты', to: '/sprints', icon: CalendarClock, staffOnly: true, permission: 'view_sprints',
    hint: 'Задачи, доска и\u00a0таймлайн спринтов' },
  { label: 'Комитет', to: '/committee', icon: Landmark, permission: 'view_curated_tickets',
    hint: 'Изменения на\u00a0рассмотрении комитета' },
  { label: 'Мессенджер', to: '/messenger', icon: MessagesSquare, staffOnly: true, messengerBadge: true,
    hint: 'Переписка с\u00a0коллегами и\u00a0каналы\u00a0групп' },
  { label: 'Аналитика', to: '/analytics', icon: BarChart3, staffOnly: true,
    hint: 'Отчёты по\u00a0заявкам за\u00a0выбранный период' },
  { label: 'KPI', to: '/kpi', icon: Trophy, staffOnly: true,
    hint: 'Начисления и\u00a0рейтинг инженеров за\u00a0месяц' },
  { label: 'Активация VPN', href: 'https://my.pridex.ru/', icon: Globe,
    hint: 'Подключить доступ к\u00a0внутренней сети' },
  { label: 'Pridex Wiki', href: 'https://wiki.pridex.local/', icon: BookOpen,
    hint: 'База знаний компании' },
  { label: 'Pridex Plus', href: 'https://plus.pridex.ru/profile', icon: Plus,
    hint: 'Ваш профиль в\u00a0Pridex\u00a0Plus' },
];

